import ReportMining from './reportMining'

export default ReportMining
